document.addEventListener('DOMContentLoaded', function () {
  // Variables
  const wrappers = document.getElementsByClassName('content-accordions')

  // Initializing Items
  for (let i = 0; i < wrappers.length; i++) {
    // Variables
    const wrapper = wrappers[i]
    const accordions = wrapper.querySelectorAll('.accordion')

    for (let o = 0; o < accordions.length; o++) {
      const accordion = accordions[o]
      const button = accordion.querySelector('.accordion__button')
      const content = accordion.querySelector('.accordion__content')

      button.addEventListener('click', function (evt) {
        // if (evt.target.tagName.toLowerCase() !== 'a') {
          if (!accordion.classList.contains('accordion--active')) {
            let activeAccordion = wrapper.querySelector('.accordion--active')

            if(activeAccordion) {
              let activeButton = activeAccordion.querySelector(".accordion__button")
              let activeContent = activeAccordion.querySelector(".accordion__content")
              activeAccordion.classList.remove('accordion--active')
              activeButton.setAttribute('aria-expanded', false)
              activeContent.setAttribute('aria-hidden', true)
            }

            accordion.classList.add('accordion--active')
            button.setAttribute('aria-expanded', true)
            content.setAttribute('aria-hidden', false)
          } else {
            accordion.classList.remove('accordion--active')
            button.setAttribute('aria-expanded', false)
            content.setAttribute('aria-hidden', true)
          }
        // }
      })
    }
  }
})
